import http from '@/requests/http'
import appConfig from '@/config/app'
import utilityHelper from '@/helpers/utils'

class Consultation {
  static all (params) {
    return http.post('consultation/index', params)
  }
  static list (params) {
    return http.post('consultation/list', params)
  }
  static async update (data) {
    return http.post('consultation/update', data)
  }
  static async updateConsultation (data) {
    return http.post('consultation/update-consultation', data)
  }
  static async store (data) {
    return http.post('consultation/store', data)
  }
  static async storeOutbound (data) {
    return http.post('consultation/outbound/store', data)
  }
  static async delete (id) {
    return http.post(`consultation/delete/${id}`)
  }
  static async getSmallByBig (params) {
    return http.post('consultation/get-small-by-big', params)
  }
  static async export (params) {
    const URLparams = new URLSearchParams(Object.entries(params))
    window.open(`${appConfig.apiBaseUrl  }/consultation/export?${URLparams}`, '_blank')
  }
  static async downloadRecording (params) {
    const URLparams = new URLSearchParams(Object.entries(params))
    window.open(`${appConfig.apiBaseUrl  }/consultation/download-recording?${URLparams}`, '_blank')
  }
  static async downloadOneTouchRecording (params) {
    const URLparams = new URLSearchParams(Object.entries(params))
    window.open(`${appConfig.apiBaseUrl  }/consultation/download-one-touch-recording?${URLparams}`, '_blank')
  }
  static async view (params) {
    return http.post('member/outbound', params)
  }
  static async viewConsultation (params) {
    return http.post('consultation/view', params)
  }
  static async historyFindAll (params) {
    return http.post('consultation/history', params)
  }
  static async companyList (params) {
    return http.post('consultation/company/list', params)
  }
  static async downloadSampleImportFile (id, language) {
    window.open(`${appConfig.apiBaseUrl  }/consultation/import/${id}/sample/${language}`, '_blank')
  }
  static async import (data) {
    const formData = new FormData()
    await utilityHelper.buildFormData(formData, data)
    return http.post('consultation/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export default Consultation
